import React from "react";
import CardLayout from "../CardLayout";

const SectionCommonTable = ({
  wrapperClassName,
  cardStyle,
  sectionTableTitle,
  countContainer,
  table,
  calculateCredit,
  calculateDebit,
  calculateContainer,
}) => {
  return (
    <div className={`mono_sectiontable_wrapper ${wrapperClassName}`}>
      <CardLayout style={cardStyle} className="mono_sectiontable_card">
        <div className="mono_sectiontable_title">
          <h2>{sectionTableTitle}</h2>
          {countContainer && (
            <div className="mono_sectiontable_balance">
              <h2>{countContainer}</h2>
            </div>
          )}
        </div>
        <div className="mono_sectiontable_table">{table}</div>
        {calculateContainer && (
          <div className="mono_sectiontable_calculate">
            {calculateCredit && (
              <h2 className="credit_balance">{calculateCredit}</h2>
            )}
            {calculateDebit && (
              <h2 className="debit_balance">{calculateDebit}</h2>
            )}
          </div>
        )}
      </CardLayout>
    </div>
  );
};

export default SectionCommonTable;
